import { createRoot } from "react-dom/client";
import AppStatic from "./AppStatic";
import "./styles.css";
import { applyStoredTheme } from "@/shared/theme/themeApply";

console.log("[static] boot", { href: window.location.href });

window.addEventListener("error", (event) => {
  console.error("[static window.error]", event.error || event.message);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("[static unhandledrejection]", event.reason);
});

// Áp theme local ngay (tránh flash) + đồng bộ remote từ /api/theme (best-effort).
// Phải gọi TRƯỚC render để DOM data-theme có sẵn cho first paint nếu có cache.
try { applyStoredTheme(); } catch (e) { console.warn("[static] applyStoredTheme failed", e); }

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(<AppStatic />);
